import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';

// TODO: CHANGE THE LOCATION OF THIS FILE
import Checkmark from '../../../assets/svg/Checkmark';
import { DisplayCheckbox, Label } from '../Modals/AuthModalComponents/Form';

import colors from '../../../styling/colors';
import {
  MOBILE_END_QUERY,
  DESKTOP_START_QUERY,
} from '../../../styling/mixins/responsive';

import HandOffLink from '../../../utils/urls/HandOffLink';
import { toggleQueryParameter } from '../../../utils/urls/urlGenerator';

import {
  trackSelectSort,
  trackToggleFilter,
} from '../../../redux/filters.tracking';
import TrackingContext from '../../../tracking/TrackingContext';

const SELECTION_LINE_HEIGHT = 1.5;
const SELECTION_VERT_PADDING = 0.375;
export const SELECTION_TOTAL_HEIGHT =
  SELECTION_VERT_PADDING * 2 + SELECTION_LINE_HEIGHT;
export const SELECTION_LAST_BOTTOM_MARGIN = 1.5;

const SelectionContainer = styled(HandOffLink)`
  align-items: baseline;
  display: flex;
  font-size: 0.875rem;
  padding: 0.75rem 0;
  cursor: pointer;
  line-height: ${SELECTION_LINE_HEIGHT};

  &:last-child {
    padding-bottom: ${SELECTION_LAST_BOTTOM_MARGIN}em;
  }

  @media (${MOBILE_END_QUERY}) {
    &:first-child {
      padding-top: 1.5rem;
    }
  }

  @media (${DESKTOP_START_QUERY}) {
    padding: ${SELECTION_VERT_PADDING}rem 0;
  }
`;

const Checkbox = styled(DisplayCheckbox)`
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0;
  border-color: ${colors('alto')};
  pointer-events: none;
`;

const CheckmarkContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 2rem;
  margin-right: 0.25rem;
`;

const Filter = styled(Label)`
  align-items: center;
  font-size: 1rem;
  flex-grow: 0;
  pointer-events: none;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 0.75rem;
  }
`;

const DisplayName = styled.div`
  @media (${DESKTOP_START_QUERY}) {
    width: 100%;
  }
`;

const FilterSelection = ({
  name,
  filterType,
  on,
  isMobile,
  type,
  value,
  trackSelectSort,
  trackToggleFilter,
}) => {
  const routerProps = useRouter();
  const { filterSelectionType } = useContext(TrackingContext);

  const SelectionIndicator = isMobile ? (
    <CheckmarkContainer>
      <Checkmark width={on ? '1.5rem' : '0'} height="1.5rem" />
    </CheckmarkContainer>
  ) : (
    <Checkbox checked={on} />
  );

  const hrefValue = { query: { page: 1 } };
  const singleValueSelection = filterType === 'sort';
  hrefValue.query[type] = toggleQueryParameter(
    value,
    routerProps.query[type],
    singleValueSelection,
  );

  const trackingCallback = () => {
    if (filterType === 'sort') {
      trackSelectSort(name, filterSelectionType);
    } else {
      trackToggleFilter(type, value, !on, filterSelectionType);
    }
  };

  return (
    <SelectionContainer
      href={hrefValue}
      preRedirects={[trackingCallback]}
      scroll={false}
      preventLinkTracking
    >
      <Filter key={name}>
        {SelectionIndicator}
        <DisplayName>{name}</DisplayName>
      </Filter>
    </SelectionContainer>
  );
};

FilterSelection.propTypes = {
  name: PropTypes.string.isRequired,
  filterType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  on: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

const mapDispatchToProps = {
  trackSelectSort,
  trackToggleFilter,
};

export default connect(null, mapDispatchToProps)(React.memo(FilterSelection));
